<template>
  <search-select
    :options="currencies"
    v-model="currencyInput"
    placeholder=""
    :labelProvider="currencyLabel"
    :search-enabled="true"
    bg="dark"
  ></search-select>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'

export default {
  props: ['field'],
  components: {
    SearchSelect
  },
  computed: {
    value () {
      return this.field.value
    },
    currencies () {
      return this.$store.getters['dict/currencies']
    },
    currencyInput: {
      get () { return this.currencyIdx },
      set (idx) {
        this.currencyIdx = idx
        const currencyIdx = Number.isInteger(this.currencyIdx)
          ? this.currencies[this.currencyIdx].id
          : null
        this.$emit('input', { value: currencyIdx, debounced: false })
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (id) {
        const idx = this.currencies.findIndex((m) => m.id === id)
        this.currencyIdx = idx > -1 ? idx : null
      }
    }
  },
  data () {
    return {
      currencyIdx: null,
      currencyLabel: (c) => {
        return c ? c.name + ' : ' + c.full_name : c
      }
    }
  }
}
</script>
